import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLoadingCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="loading-circle, quarter, spinner"><path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeOpacity="0.3"/><path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5" stroke="currentColor"/></CentralIconBase>;
};

export default IconLoadingCircle;
